import React from 'react';
import { useTranslation } from 'react-i18next';
import { Sparkles } from 'lucide-react';

// Shown across the top of the app while in demo mode. Its CTA exits demo and
// lands the user on the marketing page with the registration modal open
// (wired in App via onCreateAccount).
const DemoBanner = ({ onCreateAccount }) => {
    const { t } = useTranslation();
    return (
        <div className="demo-banner" role="region" aria-label={t('demoBanner.aria', 'Demo mode')}>
            <span className="txt">
                <Sparkles size={16} />
                <b>{t('demoBanner.label', "You're exploring a demo. Nothing here is saved.")}</b>
                <span className="sub">{t('demoBanner.sub', 'Create a free account to save your own plan.')}</span>
            </span>
            <button type="button" className="btn btn-grad btn-sm" onClick={onCreateAccount}>
                {t('demoBanner.cta', 'Create free account')}
            </button>
        </div>
    );
};

export default DemoBanner;
